<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>赛事图片</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            placeholder="请输入标题"
            v-model="queryInfo.Title"
            clearable
            @clear="getMatchImgList(1)"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getMatchImgList(1)"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showDialog('add')">添加</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="Title" label="标题" width="800">
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="添加时间"
          :formatter="dataFormat"
        >
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="showDialog('edit', scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteCreate(scope.row.MatchPicturesID)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
      <!-- 修改 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="editDialogVisible"
        width="30%"
        @close="editresetFields"
        v-loading="loading"
        element-loading-text="正在上传中"
        element-loading-spinner="el-icon-loading"
      >
        <el-form
          :model="editForm"
          :rules="editRules"
          ref="editFormRef"
          label-width="100px"
        >
          <el-form-item label="标题" prop="Title">
            <el-input v-model="editForm.Title"></el-input>
          </el-form-item>
          <el-form-item label="赛事图片" prop="ImageUrl">
            <el-upload
              class="avatar-uploader"
              ref="uploadref"
              :action="urlApi"
              :data="editForm"
              :limit="1"
              :on-exceed="handleExceed"
              :headers="headers"
              :show-file-list="false"
              :on-change="uploadChange"
              :on-success="handleAvatarSuccess"
              :on-progress="uploadProcess"
              :auto-upload="false"
              :file-list="fileList"
              list-type="picture"
            >
              <i
                class="el-icon-plus avatar-uploader-icon"
                style="border: 1px solid #ddd"
                v-if="editForm.ImageUrl === ''"
              ></i>
            </el-upload>
            <div v-if="editForm.ImageUrl">
              <el-image
                class="avatar"
                :src="editForm.ImageUrl"
                :preview-src-list="srcList"
              >
              </el-image>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addImg()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        Title: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 修改弹框显示状态
      editDialogVisible: false,
      dialogTitle: '',
      editForm: {
        Title: '',
        ImageUrl: ''
      },
      // 修改表单验证
      editRules: {
        Title: [
          {
            required: true,
            message: '请输入标题',
            trigger: 'blur'
          }
        ],
        ImageUrl: [
          {
            required: true,
            message: '请上传图片',
            trigger: 'change'
          }
        ]
      },
      // 图片上传接口地址
      urlApi: '',
      headers: { Authorization: '' },
      loading: false,
      // 图片预览
      srcList: [],
      fileList: [],
      // 添加修改类型
      changestu: true,
      // 上传前文件类型是否验证通过
      fileTypeStatus: true
    }
  },
  created() {
    //   默认获取列表
    this.getMatchImgList(1)
    this.getToken()
  },
  methods: {
    //   获取列表
    async getMatchImgList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/MatchPictures/GetMatchPictures',
        { params: this.queryInfo }
      )
      // console.log(res)
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.matchPictures
      this.total = res.Data.total
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getMatchImgList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getMatchImgList(newPage)
    },
    handleAvatarSuccess(res) {
      console.log(res)
      this.loading = false
      this.editForm.ImageUrl =
        process.env.VUE_APP_BASE_URL + res.Data.matchPicturesFile.FileName
      this.srcList.push(
        process.env.VUE_APP_BASE_URL + res.Data.matchPicturesFile.FileName
      )
      this.$message.success(res.Msg)
    },
    clearfile() {
      // 清空文件列表
      this.$refs.uploadref.clearFiles()
      console.log(this.fileList)
    },
    // 上传状态
    uploadProcess(event, file, fileList) {
      this.loading = true
    },
    uploadChange(file, fileList) {
      var fileSize = file.size / 1024 / 1024 < 2
      if (
        [
          'image/jpeg',
          'image/jpg',
          'image/gif',
          'image/bmp',
          'image/png'
        ].indexOf(file.raw.type) === -1
      ) {
        this.$message.error('上传图片只能是 JPG、JPEG、gif、bmp、PNG 格式!')
        this.clearfile()
        return false
      }
      if (!fileSize) {
        this.$message.error('上传图片大小不能超过 2MB!')
        this.clearfile()
        return false
      }
      if (this.editForm.ImageUrl === '') {
        this.editForm.ImageUrl = file.url
      }
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]
      }

      return true
    },
    handleExceed(files, fileList) {
      this.$message.warning('最多可以上传1个视频')
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.editForm = {
        Title: '',
        ImageUrl: ''
      }
      this.$refs.editFormRef.clearValidate()
    },
    showDialog(type, row) {
      if (type === 'add') {
        this.dialogTitle = '添加赛事图片'
        this.editDialogVisible = true
        this.fileList = []
        this.urlApi =
          process.env.VUE_APP_BASE_URL + '/api/MatchPictures/AddMatchPictures'
        this.changestu = true
      } else if (type === 'edit') {
        this.dialogTitle = '修改赛事图片'
        this.changestu = false
        this.editForm = row
        this.editForm.ImageUrl = process.env.VUE_APP_BASE_URL + row.FileName
        this.urlApi =
          process.env.VUE_APP_BASE_URL +
          '/api/MatchPictures/UpdateMatchPictures'
        this.editDialogVisible = true
        if (this.srcList.length === 0) {
          this.srcList.push(process.env.VUE_APP_BASE_URL + row.FileName)
        }
      }
    },
    addImg() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // 发起添加请求
        const formData = new FormData()
        if (this.changestu === true) {
          formData.append('file', this.fileList[0].raw)
          formData.append('Title', this.editForm.Title)
        } else {
          formData.append('file', this.fileList[0].raw)
          formData.append('Title', this.editForm.Title)
          formData.append('MatchPicturesID', this.editForm.MatchPicturesID)
        }
        const { data: res } = await this.$http.post(this.urlApi, formData)
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getMatchImgList(1)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/MatchPictures/DelMatchPictures?matchPicturesID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getMatchImgList(1)
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    getToken() {
      this.headers.Authorization = window.localStorage.getItem('token')
    }
  }
}
</script>
<style lang="less" scoped>
.el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  display: block;
}
</style>
